import React from "react";

const InactiveUserIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      opacity="0.3"
      d="M37 0C49.7025 0 60 10.2975 60 23V37C60 49.7025 49.7025 60 37 60H23C10.2975 60 0 49.7025 0 37V23C0 10.2975 10.2975 0 23 0H37Z"
      fill="#FF9066"
    />
    <path
      opacity="0.78"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.6319 23.8088C28.6519 23.5483 28.8692 23.3472 29.1304 23.3472H29.5482C29.8051 23.3472 30.0202 23.5418 30.0458 23.7974L30.6674 30.0138L35.0821 32.5365C35.2379 32.6256 35.3341 32.7912 35.3341 32.9707V33.3592C35.3341 33.6889 35.0206 33.9283 34.7025 33.8416L28.3994 32.1226C28.168 32.0595 28.014 31.841 28.0324 31.6018L28.6319 23.8088Z"
      fill="#FF9066"
    />
    <path
      opacity="0.901274"
      d="M21.8525 15.1904C21.9479 14.7908 22.4575 14.6698 22.7217 14.9844L24.5205 17.1289C26.2036 16.4122 28.0552 16.0137 30 16.0137C37.7319 16.0137 43.9998 22.2818 44 30.0137C44 37.7457 37.732 44.0137 30 44.0137C22.268 44.0137 16 37.7457 16 30.0137C16 28.7006 16.1805 27.4297 16.5186 26.2246L19.0859 26.9453C18.8086 27.9342 18.667 28.9632 18.667 30.0137C18.667 36.2729 23.7408 41.3477 30 41.3477C36.2592 41.3477 41.333 36.2729 41.333 30.0137C41.3328 23.7546 36.2591 18.6807 30 18.6807C28.7318 18.6807 27.4968 18.8891 26.332 19.2871L28.1328 21.4336C28.3974 21.7489 28.1892 22.2306 27.7783 22.2539L20.7334 22.6533C20.3992 22.6722 20.1411 22.3637 20.2188 22.0381L21.8525 15.1904Z"
      fill="#FF9066"
    />
  </svg>
);

export default InactiveUserIcon;
